const slideActiveDefaultState = {
  slideActive: {
    // OPEN ENDED AI GROUPING
    isOpenEndedGroupingLayout: false,
    isOpenEndedGroupingLoading: false,
    openEndedAIGroupedAnswers: [],
    wordCloudSmartGrouping: [],
    isGroupWordCloudWords: false,
    showFullImageQuestion: false,
    isTextBlockEditing: false,
  },
  startPresentingFromSlideId: null,
}

export default slideActiveDefaultState
